import { render, staticRenderFns } from "./event-capacity-info-dialog.vue?vue&type=template&id=542eedd1"
import script from "./event-capacity-info-dialog.vue?vue&type=script&lang=js"
export * from "./event-capacity-info-dialog.vue?vue&type=script&lang=js"
import style0 from "./event-capacity-info-dialog.vue?vue&type=style&index=0&id=542eedd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports